import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Container, Col, Row, Modal, Button } from 'reactstrap';
import axios from 'axios';
import { Document, Page } from 'react-pdf';
import { Menu } from 'antd';
import Loading from '../../../components/Loading';
import { cloudFrontCdnUrl, s3SupportDocs } from '../../../config/properties';
import history from '../../../config/history';
import './newsletters.scss';
import NFButton from '../../../components/primitives/NFButton';

export default class Newsletters extends React.Component {
  state = {
    loading: true,
    numPages: null,
    pageNumber: 1,
    nFile: null,
    folderNames: [],
    isAuthenticated: false,
    authModalOpen: false,
  };

  // Helper to get idToken from cookies
  static getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  async componentDidMount() {
    // Check if user is authenticated
    const token = Newsletters.getCookie('idToken');
    const isAuthenticated = !!token;

    this.setState({ isAuthenticated });

    // If not authenticated, show auth modal and store redirect URL
    if (!isAuthenticated) {
      // Store current page URL for redirect after login
      sessionStorage.setItem('auth_redirect_url', window.location.pathname);
      this.setState({ authModalOpen: true });
      return;
    }

    // Only load newsletters if user is authenticated
    try {
      const xml = await axios.get(`${cloudFrontCdnUrl}`);
      const folderNames = await this.getS3FolderFiles('Newsletters/', xml);
      this.setState({
        folderNames,
      });
    } catch (error) {
      console.error(error);
    }
  }

  onDocumentLoadSuccess = async ({ numPages }) => {
    await this.setState({
      numPages,
    });
  };

  getS3FolderFiles = (s3FolderName, xmlText) => {
    this.setState({ loading: true });

    let xmlDoc = '';
    let parser = '';
    let xmlNode = '';
    const nLetters = [];
    let folderNames = [];

    parser = new DOMParser();
    xmlDoc = parser.parseFromString(xmlText.data, 'text/xml');

    for (let i = 0; i < xmlDoc.getElementsByTagName('Contents').length; i += 1) {
      xmlNode = xmlDoc.getElementsByTagName('Contents')[i].childNodes[0]
        .childNodes[0].nodeValue;
      if (
        xmlNode.startsWith(s3FolderName) &&
        xmlNode.length > s3FolderName.length
      ) {
        nLetters.push(xmlNode.substring(s3FolderName.length, xmlNode.length));
      }
    }
    nLetters.sort().reverse();
    if (nLetters.length > 0) {
      folderNames = nLetters.map(nFile => (
        <Menu.Item key={nFile} title={nFile.split('.pdf')[0]}>
          {nFile.split('.pdf')[0]}
        </Menu.Item>
      ));
    }
    this.setState({
      loading: false,
      nFile: folderNames.length > 0 ? folderNames[0].key : null,
    });

    return folderNames;
  };

  changePage = offset =>
    this.setState(prevState => ({
      pageNumber: prevState.pageNumber + offset,
    }));

  previousPage = () => this.changePage(-1);
  nextPage = () => this.changePage(1);

  handleClick = e => {
    this.setState({ nFile: e.key, numPages: null, pageNumber: 1 });
  };

  _onClick = () => {
    const href = `${s3SupportDocs}/Newsletters/${this.state.nFile}`;
    window.open(href, '_blank');
  };

  // Close auth modal handler
  closeAuthModal = () => {
    this.setState({ authModalOpen: false });
    // Redirect to home after closing
    history.push('/');
  }

  render() {
    const { numPages, pageNumber, nFile, isAuthenticated, authModalOpen } = this.state;
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Newsletters Page</title>
          <meta
            name="description"
            content="Read the latest news and learn about the latest events associated with the ICON Portal user community."
          />
          <meta
            name="keywords"
            content="icon portal user community, icon newsletters, cast components, foundries"
          />
        </Helmet>

        {/* Authentication Modal */}
        <Modal isOpen={authModalOpen} toggle={this.closeAuthModal} className="auth-modal" size="md">
          <div className="text-center p-5">
            <div className="alert alert-danger">
              Please log in to view newsletters. You must be a member to access newsletter content.
            </div>
            <div className="mt-3">
              <Link to="/login" className="btn mr-2" style={{ backgroundColor: '#ff914d', borderColor: '#ff914d', color: '#fff' }}>Sign In</Link>
              <Link to="/register" className="btn" style={{ backgroundColor: '#fff', borderColor: '#ef4136', color: '#ef4136' }}>Register</Link>
            </div>
            <div className="mt-3">
              <Button style={{ backgroundColor: '#000000', borderColor: '#000000', color: '#fff' }} onClick={this.closeAuthModal}>Close</Button>
            </div>
          </div>
        </Modal>
        {isAuthenticated && (
          <React.Fragment>
            <div className="newsletter-bottom">
              <Col xs={1} />
              <Row>
                <div style={{ width: 400 }}>
                  <h1 className="newsletter-header">Newsletters</h1>
                </div>
                <div className="newsletter-header">
                  To enable links in the document please open or download the pdf.
                </div>
              </Row>

              <div className="newsletter-wrapper">
                <div>
                  <Menu
                    onClick={this.handleClick}
                    style={{ width: 300 }}
                    selectedKeys={[nFile]}
                    mode="inline"
                  >
                    {this.state.folderNames}
                  </Menu>
                </div>
                {!this.state.loading && (
                  <div>
                    <a
                      href={`${s3SupportDocs}/Newsletters/${this.state.nFile}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Document
                        file={`${cloudFrontCdnUrl}/Newsletters/${this.state.nFile}`}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                      >
                        <Page pageNumber={pageNumber} />
                      </Document>
                    </a>

                    {numPages && (
                      <div>
                        <p>
                          Page {pageNumber || (numPages ? 1 : '--')} of{' '}
                          {numPages || '--'}
                        </p>
                        <div className="newsletter-button-container">
                          <NFButton
                            className="nf-button newsletter-button nf-button--gray "
                            type="button"
                            disabled={pageNumber <= 1}
                            onClick={this.previousPage}
                          >
                            Previous
                          </NFButton>
                          <NFButton
                            className="nf-button newsletter-button nf-button--gray "
                            type="button"
                            disabled={pageNumber >= numPages}
                            onClick={this.nextPage}
                          >
                            Next
                          </NFButton>
                          <button
                            className="newsletter-button"
                            onClick={this._onClick}
                            title={[nFile]}
                          >
                            Open / Download PDF
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {this.state.loading && <Loading test="oof" />}
          </React.Fragment>
        )}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/static/newsletters/newsletters.jsx